module.exports = __webpack_public_path__ + "static/media/Zelda.4a13a059.png";